import { render, staticRenderFns } from "./DownloadComponent.vue?vue&type=template&id=ddd41b68&scoped=true&"
import script from "./DownloadComponent.vue?vue&type=script&lang=ts&"
export * from "./DownloadComponent.vue?vue&type=script&lang=ts&"
import style0 from "./DownloadComponent.vue?vue&type=style&index=0&id=ddd41b68&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddd41b68",
  null
  
)

export default component.exports